import * as angular from "angular";
import {IController} from "angular";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {ServiceAnalysisRequestsService} from "../../services/service-analysis-requests.service";

export class analysisLogsViewCtrl implements IController {

  id: any;
  log: any;

  private loading: boolean;
  private isDone: boolean;
  private doReload: boolean;

  /* @ngInject */
  constructor(private serviceAnalysisRequestsService: ServiceAnalysisRequestsService, private leanPlanningAlertsService: LeanPlanningAlertsService, private $log) {
  }

  $onInit() {
    this.loading = false;
    this.isDone = false;
    this.doReload = false;
  };

  abortLogById(id) {
    this.loading = true;
    this.serviceAnalysisRequestsService.cancelGeneratingRouteById(id)
      .then(() => {
        this.leanPlanningAlertsService.cancelGeneratingSuccess();
        this.doReload = true;

      })
      .catch((error) => {
        this.leanPlanningAlertsService.cancelGeneratingError();
        this.$log.error('Failed to abort generating task, @analysisLogsView@abortLogById', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onReloadLogs() {
    this.doReload = false;
  }


}

angular
  .module('bringoz.admin.service-analysis')
  .component('analysisLogsView', {
    bindings: {},
    template: require('./analysis-logs-view.html').default,
    controller: analysisLogsViewCtrl
  });
